export const WindsorId = "653dbfa79c1fb301f4375e13";
export const TorontoId = "653dbf639c1fb301f4375e0f";
export const WithInPickUpArea = "6564e158f3d3c3b55fe5854b";
export const TorontoAirportId = "653dc04d9c1fb301f4375e63";
